import React from "react";

/** Status metadata for policy workflow (Fase 2). */
export const POLICY_STATUS_META = {
  bozza: {
    label: "Entwurf", short: "B",
    bg: "bg-slate-200", text: "text-slate-700", dot: "bg-slate-500",
    border: "border-slate-300",
  },
  in_Revision: {
    label: "In Revision", short: "R",
    bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500",
    border: "border-amber-300",
  },
  documenti_completi: {
    label: "Dokumente Komplett", short: "DC",
    bg: "bg-sky-100", text: "text-sky-800", dot: "bg-sky-500",
    border: "border-sky-300",
  },
  genehmigtto_control: {
    label: "Genehmigt (Mit Finma)", short: "AC",
    bg: "bg-emerald-100", text: "text-emerald-800", dot: "bg-emerald-500",
    border: "border-emerald-300",
  },
  attesa_compagnia: {
    label: "Warten auf Gesellschaft", short: "AT",
    bg: "bg-indigo-100", text: "text-indigo-800", dot: "bg-indigo-500",
    border: "border-indigo-300",
  },
  attivo: {
    label: "Aktiv", short: "A",
    bg: "bg-green-100", text: "text-green-800", dot: "bg-green-600",
    border: "border-green-400",
  },
  pagato: {
    label: "Bezahlt", short: "P",
    bg: "bg-violet-100", text: "text-violet-800", dot: "bg-violet-600",
    border: "border-violet-300",
  },
  stornato: {
    label: "Storniert", short: "S",
    bg: "bg-red-100", text: "text-red-800", dot: "bg-red-600",
    border: "border-red-300",
  },
};

export const POLICY_FLOW_ORDER = [
  "bozza", "in_Revision", "documenti_completi", "genehmigtto_control",
  "attesa_compagnia", "attivo", "pagato",
];

export function getPolicyStatusMeta(status) {
  return POLICY_STATUS_META[status] || POLICY_STATUS_META.bozza;
}

export default function PolicyStatusBadge({ status, className = "" }) {
  const m = getPolicyStatusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded ${m.bg} ${m.text} ${className}`}
      data-testid={`policy-status-${status}`}
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${m.dot}`} />
      {m.label}
    </span>
  );
}
